import { cx } from './cx.ts'

import './badge.css'

/**
 * 낡음(stale) 표지 — 「응답 없음」 + 마지막 응답 시각.
 *
 * 🔴 **투명도로 흐리지 않는다**(정본 07 · 계약 `ModuleSnapshot.stale` 2026-09-25 개정 —
 *    「낡음 표기 · 투명도 아님 · 글자 대비 4.5:1 이상 + 응답 없음 + 마지막 값 병기」).
 *    종전 모니터링 카드는 `opacity: 0.7`(6축 레일은 0.45)로 흐렸다 — 흐린 글자는 대비가 무너지고
 *    **「무엇이 낡았는지」를 말하지 않는다.** 이 표지는 글자로 말한다.
 * 🔴 **색만으로 가르지 않는다** — 글리프(◌ · 점선 원 = 「모른다」) + 글자 + 점선 테두리.
 *    글자색은 본문 먹색(`--color-fg`)이라 어느 스킨에서도 4.5:1 을 넘긴다.
 * 🔴 원자는 한글을 만들지 않는다 — `label`(「응답 없음」) · `detail`(「마지막 응답 09-19 10:24」)을 받는다.
 */
export type StaleMarkProps = {
  label: string
  /** 마지막 응답 시각 같은 덧말. 없으면 표지만 선다 */
  detail?: string | undefined
  className?: string | undefined
}

export function StaleMark({ label, detail, className }: StaleMarkProps) {
  return (
    <span className={cx('a-stale', className)}>
      <i aria-hidden="true" className="a-stale__glyph">
        ◌
      </i>
      <span>{label}</span>
      {detail === undefined ? null : <span className="a-stale__detail">· {detail}</span>}
    </span>
  )
}
